import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import HeroBanner from "../../../components/app/homescreen/HeroBanner/HeroBanner";
import TodaysReminders from "../../../components/app/homescreen/TodaysReminders/TodaysReminders";
import TodaysProgress from "../../../components/app/homescreen/TodaysProgress/TodaysProgress";
import Layout from "../../../components/app/layout/Layout";
import PoweredByLogo from "../../../components/app/homescreen/PoweredByLogo";
import WalletCard from "../../../components/app/homescreen/WalletCard";
import BookAppointment from "../../../components/app/homescreen/BookAppointment";
import DevicesCard from "../../../components/app/homescreen/DevicesCard";

import { setThemeColors } from "../../../helpers/common";
import JourneyCard from "src/components/app/progress/JourneyCard";
import ServicesCard from "src/components/app/progress/ServicesCard";
import HealthStoreCard from "src/components/app/progress/HealthStoreCard";
import EducationalContentCard from "src/components/app/progress/EducationalContentCard";
import ProgramBenefits from "src/components/app/review-state/ProgramBenefits";
import HomeScreen from "../HomeScreen";
import ProgramScreen from "../ProgramScreen";
import HealthAssistantScreen from "../HealthAssistantScreen";
import RecordsScreen from "../RecordsScreen/RecordsScreen";
import LogDetailsScreen from "../LogDetailsScreens/LogDetailsScreen";
import supportPrograms from "src/data/app/programs";
import MedicationLogDetailsScreen from "../LogDetailsScreens/MedicationLogDetailsScreen";
import MenstruationLogDetailsScreen from "../LogDetailsScreens/MenstruationLogDetailsScreen";
import { generateTheme } from "src/helpers/theme";
import HealthAssistantScreenIframe from "../HealthAssistantScreenIframe";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as goalsActions from "src/redux/slices/goalsSlice";
import ChatScreen from "../ChatScreen";

const DynamicScreen: React.FC = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const { patient } = useAppSelector((state) => state.auth);

  const supportProgramKey = params["support-program-key"];
  const screenName = params["screen-name"];
  const insightsTab = params["tab"];
  const insightsVitalId = params["vitalId"];

  // const programDetails = supportPrograms[supportProgramKey as keyof typeof supportPrograms];
  const config =
    supportPrograms[supportProgramKey as keyof typeof supportPrograms];

  // setThemeColors(config?.theme?.colors);
  setThemeColors(generateTheme(config?.theme?.colors));

  // const supportProgram =
  //   supportProgramKey && supportPrograms.hasOwnProperty(supportProgramKey)
  //     ? supportPrograms[supportProgramKey as keyof typeof supportPrograms]
  //     : undefined;

  // const appScreens = supportProgram?.appScreens;

  // const screenData =
  //   supportProgram && screenName && appScreens
  //     ? appScreens[screenName as keyof typeof appScreens]
  //     : undefined;

  useEffect(() => {
    // if (screenName === "home-screen") {
    getGoals();
    // }
  }, [screenName]);

  const getGoals = () => {
    new Promise((resolve, reject) => {
      dispatch(
        goalsActions.getGoalsRequest({
          payload: { user_id: patient?.data?.patient_id },
          resolve,
          reject,
        })
      );
    });
  };

  const appScreens = config?.app?.screens;
  const screenData = appScreens?.[screenName as keyof typeof appScreens];

  const getComponents = (componentData: any) => {
    switch (componentData?.id) {
      case "hero-section":
        return (
          <HeroBanner
            {...componentData}
            supportProgramKey={supportProgramKey}
          />
        );

      case "health-progress-card":
        return <ProgramBenefits supportProgramKey={supportProgramKey || ""} />;

      case "today-progress-card":
        return (
          <TodaysProgress
            {...componentData}
            supportProgramKey={supportProgramKey}
          />
        );

      case "reminders-card":
        return (
          <TodaysReminders
            {...componentData}
            supportProgramKey={supportProgramKey}
          />
        );

      case "book-appointment-card":
        return <BookAppointment />;

      case "devices-card":
        return <DevicesCard />;

      case "wallet-card":
        return <WalletCard />;

      case "powered-by-logo":
        return (
          <PoweredByLogo
            supportProgramKey={supportProgramKey ?? ""}
            imageUrl={componentData.image_url}
          />
        );

      case "journey-card":
        return <JourneyCard type={componentData.type} />;

      case "services-card":
        return (
          <ServicesCard
            {...componentData}
            supportProgramKey={supportProgramKey}
          />
        );

      case "health-store-card":
        return <HealthStoreCard componentData={componentData} />;

      case "educational-content-card":
        return (
          <EducationalContentCard
            {...componentData}
            supportProgramKey={supportProgramKey}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Layout
      showBottomBar={true}
      supportProgramKey={supportProgramKey ?? ""}
      className={
        screenName === "health-assistant-screen" ? "bg-white" : "bg-transparent"
      }
    >
      <div
        className="flex flex-col gap-4 overflow-y-auto h-full"
        id="scrollableTarget"
      >
        {screenName === "records-screen" ? (
          <RecordsScreen supportProgramKey={supportProgramKey} />
        ) : screenName === "home-screen" ? (
          <HomeScreen
            screenData={screenData}
            supportProgramKey={supportProgramKey}
          />
        ) : screenName === "program-screen" ? (
          <ProgramScreen
            screenData={screenData}
            supportProgramKey={supportProgramKey}
          />
        ) : // ) : screenName === "insights-screen" ? (
        //   <InsightsScreen
        //     screenData={screenData}
        //     supportProgramKey={supportProgramKey}
        //     insightsTab={insightsTab}
        //     insightsVitalId={insightsVitalId}
        //   />
        screenName === "health-assistant-screen" ? (
          <HealthAssistantScreenIframe />
        ) : // <HealthAssistantScreen
        //   screenData={screenData}
        //   supportProgramKey={supportProgramKey}
        // />
        screenName === "log-details-screen" ? (
          <LogDetailsScreen />
        ) : screenName === "medication-log-details-screen" ? (
          <MedicationLogDetailsScreen />
        ) : screenName === "menstruation-log-details-screen" ? (
          <MenstruationLogDetailsScreen />
        ) : screenName === "chat-screen" ? (
          <ChatScreen />
        ) : (
          Array.isArray((screenData as any)?.components) &&
          (
            screenData as unknown as { components: { id: string }[] }
          ).components.map((component) => (
            <div key={component.id}>{getComponents(component)}</div>
          ))
        )}

        {/* {Array.isArray((screenData as any)?.tabs) &&
        (
          screenData as {
            tabs: {
              tabId: string;
              tabName: string;
              tabContent?: { id: string }[];
            }[];
          }
        ).tabs?.map((tab) => <div key={tab.tabId}>{tab.tabName}</div>)} */}
        {/* {Array.isArray((screenData as any)?.tabs) && (
          <TabView data={screenData} />
        )} */}
      </div>
    </Layout>
  );
};

export default DynamicScreen;

const TabView: React.FC<{ data: any }> = ({ data }) => {
  const [activeTab, setActiveTab] = useState<any>(null);

  const getComponents = (componentId: string) => {
    switch (componentId) {
      case "medication-logs":
        return <div>Medication Logs</div>;

      default:
        return null;
    }
  };

  return (
    <div className="p-4">
      <div className="flex flex-row gap-2 bg-gray-100 rounded-lg p-2">
        {data.tabs?.map((tab: any) => (
          <div
            key={tab.tabId}
            onClick={() => setActiveTab(tab)}
            className={`w-full cursor-pointer px-2 py-1 text-md flex items-center justify-center ${
              activeTab?.tabId === tab.tabId
                ? "bg-white rounded-lg text-red-500"
                : ""
            }`}
          >
            {tab.tabName}
          </div>
        ))}
      </div>

      {activeTab &&
        Array.isArray((activeTab as any).tabContent) &&
        (activeTab as any).tabContent.map((component: any) => (
          <div key={component.id}>{getComponents(component.id)}</div>
        ))}
    </div>
  );
};
